import { LogBusinessRequest } from "@/libs/logger";
import { updateNewFetchDuration } from "@/libs/serverTimeSync";
import { ResponseBase } from "@/types";
import { Toast } from "antd-mobile";
import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import qs from "qs";
import * as Sentry from '@sentry/react'
import FingerprintJS from "@fingerprintjs/fingerprintjs";

//获取指纹信息
const getFingerprintId = async () => {
  const fpPromise = await FingerprintJS.load();
  const result = await fpPromise.get();  // 调用fpPromise.get()获取访问者指纹信息，并返回一个包含指纹ID和其他信息的结果对象。

  const {
    hdr,//是否支持动态范围
    math,
    domBlockers,
    touchSupport,
    screenFrame,// 屏幕 可用区域外边距
    screenResolution,//屏幕分辨率
    openDatabase,
    reducedMotion,
    reducedTransparency,
    vendor,
    vendorFlavors,
    // webGlBasics,//webgl 基本信息
    // webGlExtensions,
    indexedDB, plugins,
    languages,
    // audio, 
    //排除组件
    ...components } = result.components;

  //添加组件
  const addComponents = {
    ...components,
    ua: { value: navigator.userAgent },
  };
  console.log('addComponents==', addComponents);
  const fingerprintId = FingerprintJS.hashComponents(addComponents as any);

  window.localStorage.setItem('VP-FingerprintJS-uuid', fingerprintId);
  // console.log('result.components==',addComponents);
  console.log('uuid==', fingerprintId);
  return fingerprintId;
}

export const pureAxios = axios.create();

interface BusinessAxios extends AxiosInstance {
  logout?: () => void;
}

const businessAxios: BusinessAxios = axios.create({
  timeout: 10000,
  //   baseURL: 请求 bucket 获取 api 地址
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    "device-model": "none", // 设备型号
    "operating-system": "none", // 操作系统
    uuid: "none", // 设备唯一标识符,
  },
  paramsSerializer(params) {
    return params && qs.stringify(params);
  },
  transformRequest: [
    function (data = {} /* headers */) {
      if (data instanceof FormData) {
        return data;
      }
      // 删除无效字段
      Object.keys(data).forEach((key) => {
        const value = data[key];
        if (value === "") Reflect.deleteProperty(data, key);
      });
      return qs.stringify(data);
    },
  ],
  transformResponse: [
    function (data = {}) {
      // 对 data 进行任意转换处理
      return data;
    },
  ],
});

export const setBusinessAxiosBaseURL = (url: string) => {
  businessAxios.defaults.baseURL = url;
};
export const setBusinessAxiosToken = (token: string) => {
  businessAxios.defaults.headers["Authorization"] = token;
};
export const setLogoutMethods = (logout: () => void) => {
  businessAxios.logout = logout;
};

export const setDeviceInfo = async ({ uuid, system, version, model }: any) => {


  businessAxios.defaults.headers['device-model'] = model || window.navigator.userAgent?.match(/\(([^)]+)/)?.[1] ||"";
  businessAxios.defaults.headers['operating-system'] = system + " " + version;
  if (uuid) {
    businessAxios.defaults.headers['uuid'] = uuid;
  } else {
    console.log('none uuid==');

    let FingerprintUUID = window.localStorage.getItem('VP-FingerprintJS-uuid');
    if (FingerprintUUID) {//如果本地存放了获取的指纹直接取本地uuid  没有则重新取
      businessAxios.defaults.headers["uuid"] = FingerprintUUID;
    } else {
      businessAxios.defaults.headers["uuid"] = await getFingerprintId();
    }

    const rawStr = window.localStorage.getItem("UA");
    try {
      const { os, device } = JSON.parse(rawStr as any);
      if (device)
        businessAxios.defaults.headers['device-model'] = device.vendor && device.model ? `${device.vendor} ${device.type || ""
          } ${device.model}` : window?.navigator?.userAgent?.match(/\(([^)]+)/)?.[1] || "";
      if (os) businessAxios.defaults.headers['operating-system'] = `${os.name} ${os.version}`;
    } catch (e) {

    }

  }
};

export type RequestDataOrParams = Record<string | symbol, any>;
export type RequestBase = {
  url: string;
  method?: "POST" | "GET";
  data?: Record<string, any>;
  params?: Record<string, any>;
};
export type RequestResponse<T> = {
  ok: boolean;
  status?: number;
  statusText?: string;
  data?: T;
  msg: string;
  code?: number;
};
export const request = <T = any>(
  { url, method = "POST", data = {}, params = {} }: RequestBase,
  extend: AxiosRequestConfig = {},
): Promise<RequestResponse<T>> => {
  return new Promise(async (resolve) => {
    // 处理部分API没有区分 data 和 params
    if (method === "GET") {
      params = Object.assign({}, params, data);
    }

    // 如果data 不是formdata
    if (!(data instanceof FormData)) {
      businessAxios.defaults.headers["Content-Type"] =
        "application/x-www-form-urlencoded";
    }
    const nowDate = Date.now();
    // 统一请求方便处理返回值和输出控制台日志
    businessAxios({
      url,
      method,
      data,
      params,
      ...extend,
    })
      .then((response) => {
        let data: ResponseBase.ResponseFormat<any> = {
          code: 0,
          result: "",
          systemDateTime: new Date().toLocaleString(),
          systemTimestamp: 0,
          msg: "解析失败",
        };

        try {
          data = JSON.parse(response.data);
        } catch (error) { }

        // token过期
        if (data.code === 401) {
          Toast.show("登录已过期");
          businessAxios.logout?.();
          LogBusinessRequest.warn("TOKEN过期");
        }

        // 更新请求耗时信息
        updateNewFetchDuration(data.systemTimestamp,nowDate);

        resolve({
          ok: data.code === 200,
          status: response.status,
          statusText: response.statusText,
          data: data.result,
          msg: data.msg,
          code: data.code,
        });

        return {
          ok: data.code === 200,
          status: response.status,
          statusText: response.statusText,
          data: data.result,
          msg: data.msg,
          code: data.code,
        };
      })
      .catch((error) => {
        // TODO 上报错误请求日志
        // TODO: 需要更具体的报错信息？
        const { code, message, name, stack, ...rest } = error;
        const restData = Object.keys(rest).reduce((prev: any, cur) => {
          prev[cur] = JSON.stringify(prev[cur]);
          return prev;
        }, {});

        LogBusinessRequest.error({
          code,
          message,
          name,
          stack,
          ...restData,
        });
        Sentry.captureException(new Error(`url:${url} code: ${code} msg:${message}`));
        resolve({
          ok: false,
          status: error?.response?.status,
          statusText: error?.response?.statusText,
          msg: `应用错误,请稍后再试 status: ${error?.response?.status || ""} code: ${code || ""} msg:${message || ""} `,
        });
      })
      .then((response) => {
        if (process.env.NODE_ENV !== "production") {
          console.groupCollapsed(
            `%cAPI请求%c${url} %cMETHOD%c${method} %cdata:%o%cparams:%o`,
            "margin-left: 10px;padding: 2px 1px 2px 5px; border-radius: 3px 0 0 3px; color: #fff; background: #606060; font-weight: bold;",
            "margin-right: 10px;padding: 2px 1px; border-radius: 0 3px 3px 0; color: #fff; background: #42c02e; font-weight: bold;",
            "margin-left: 10px;padding: 2px 1px 2px 5px; border-radius: 3px 0 0 3px; color: #fff; background: #606060; font-weight: bold;",
            "margin-right: 10px;padding: 2px 1px; border-radius: 0 3px 3px 0; color: #fff; background: #17a2ff; font-weight: bold;",
            "margin-left: 10px;padding: 2px 1px 2px 5px; border-radius: 3px 0 0 3px; color: #fff; background: #606060; font-weight: bold;",
            data,
            "margin-left: 10px;padding: 2px 1px 2px 5px; border-radius: 3px 0 0 3px; color: #fff; background: #606060; font-weight: bold;",
            params,
          );
          console.groupEnd();
        }
      });
  });
};
